import ApiService from '@/common/api.service'

export default {
  getSeminarList (memberId) {
    return new Promise((resolve, reject) => {
      ApiService.query('/seminar/list').then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  joinSeminar (payload) {
    return new Promise((resolve, reject) => {
      ApiService.post('/seminar/join', payload).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  cancelSeminar (payload) {
    return new Promise((resolve, reject) => {
      ApiService.post('/seminar/cancel/' + payload.id).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  referSeminar (seminarId) {
    return new Promise((resolve, reject) => {
      ApiService.query('/seminar/refer/' + seminarId).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}
